module.exports = __webpack_public_path__ + "img/flowchart.03360085.png";